import { Component, OnInit, Inject } from "@angular/core";
import { Router } from "@angular/router";
import { AuthService } from "@auth0/auth0-angular";
import { TranslateService } from "@ngx-translate/core";
import { ChangeLanguageComponent } from "src/app/shared/components/change-language/change-language.component";
import { CommonService } from "../../shared/services/common.service";
import {
  isPermissionsFLag as permissfig,
  userInfo as userFlag,
} from "../../shared/guards/permissions";
import * as _ from "lodash";
import { EventService } from "../../shared/services/event.service";
import { DOCUMENT } from "@angular/common";

import { environment } from "../../../environments/environment";

@Component({
  selector: "app-nav-bar",
  templateUrl: "./nav-bar.component.html",
  styleUrls: ["./nav-bar.component.scss"],
})
export class NavBarComponent implements OnInit {
  isCollapsed = false;
  openMap: { [name: string]: boolean } = {
    sub1: false,
    sub2: false,
    sub3: false,
    sub4: false,
    sub5: false,
    sub6: false,
    sub7: false,
    sub8: false,
    sub9: false,
  };
  // title: string;
  searchOrigan: any;
  organAdmin: any;
  organizations: any[] = [];
  isVisible = false;
  isOkLoading = false;
  isAdmin: boolean = false;
  isGlobalAdmin: boolean = false;
  isOrgAdmin: boolean = false;
  isAppUserCms: boolean = environment.isAppUserCms;
  showLogo = true;
  constructor(
    private router: Router,
    @Inject(DOCUMENT) private doc: Document,
    public auth: AuthService,
    private translate: TranslateService,
    private common: CommonService,
    public eventService: EventService
  ) { }

  ngOnInit(): void {
    this.isAdmin =
      permissfig.globalsystem || permissfig.organizationsystem ? true : false;

    this.isGlobalAdmin = permissfig.globalsystem ? true : false;
    this.isOrgAdmin = permissfig.organizationsystem ? true : false;
    this.getOrganList();

    this.searchOrigan =
      userFlag.userData["user_metadata"]?.default_organization;

    this.isVisible =
      _.isEmpty(userFlag.userData["user_metadata"]?.default_organization) &&
        !this.isAdmin &&
        !this.isAppUserCms
        ? true
        : false;

    console.log("userflag is", userFlag);
  }

  getOrganList() {
    this.common.get("organizations/query").subscribe((res: any[]) => {
      userFlag.userData["user_metadata"]?.organId?.forEach(element => {
        let organ =res.filter((item) => {
          return item['_id'] === element
        })
        this.organizations = this.organizations.concat(organ);
      });
    })
  }

  showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {
    if (!this.organAdmin) {
      this.isVisible = false;
      return;
    }

    if (!userFlag.userData["user_metadata"]) {
      userFlag.userData["user_metadata"] = {
        default_organization: this.organAdmin,
      };
    } else {
      userFlag.userData["user_metadata"]["default_organization"] =
        this.organAdmin;
    }

    const body = {
      user_metadata: userFlag.userData["user_metadata"],
    };

    this.common.put(`/user/update/${userFlag.userData["sub"]}`, body).subscribe(
      (res) => {
        this.eventService.send(this.organAdmin);
        this.searchOrigan = this.organAdmin;
        this.isVisible = false;
        this.isOkLoading = false;
      },
      (error) => {
        this.isOkLoading = false;
        console.log(error);
      }
    );
    this.isVisible = false;
  }

  organModelChange(event) {
    if (!userFlag.userData["user_metadata"]) {
      userFlag.userData["user_metadata"] = {
        default_organization: this.searchOrigan,
      };
    } else {
      userFlag.userData["user_metadata"]["default_organization"] =
        this.searchOrigan;
    }

    const body = {
      user_metadata: userFlag.userData["user_metadata"],
    };

    this.common.put(`/user/update/${userFlag.userData["sub"]}`, body).subscribe(
      (res) => {
        this.eventService.send(this.searchOrigan);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  openHandler(value: string): void {
    for (const key in this.openMap) {
      if (key !== value) {
        this.openMap[key] = false;
      }
    }
  }

  isWithPermissions(val) {
    //是否拥有权限
    return permissfig[val];
  }

  collapseChanged() {
    alert(1);
    this.showLogo = !this.isCollapsed;
  }

  logout() {
    this.auth.logout({ returnTo: this.doc.location.origin });
  }
}
